<div class="page-frame">
    <router-outlet></router-outlet>
</div>
